// extracted by mini-css-extract-plugin
export default {"noticebar":"Noticebar_noticebar__by7ja","marquee":"Noticebar_marquee__yCMdV","noticebar__text":"Noticebar_noticebar__text__fl677"};